import React, { useState } from "react";
import withStyles from 'react-jss';
import { CssType, ThemeType } from 'src/theme/jss-types';

const styles = (theme: ThemeType): CssType => ({
  floatLabel: {
    position: 'relative',
    marginBottom: '12px',
  },
  label: {
    fontSize: '12px',
    fontWeight: 'normal',
    position: 'absolute',
    left: '12px',
    top: '10px',
    transition: '0.2s ease all',
  },
  labelFloat: {
    zIndex: '10',
    position: 'absolute',
    left: '5%',
    top: '-10px !important',
    backgroundColor: 'white',
    fontSize: '10px',
  },
});

const FloatLabel = (props: any) => {
  const [focus, setFocus] = useState(false);
  const { children, label, classes, value } = props;

  return (
    <div
      className={classes.floatLabel}
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      {children}
      <label className={(focus || value) ? classes.labelFloat : classes.label}>{label}</label>
    </div>
  );
};

export default withStyles(styles, { injectTheme: true })(FloatLabel);
